export default __webpack_public_path__ + "static/media/friend.a025a2a6.svg";